module.exports = __webpack_public_path__ + "media/images/viessmann_banner/banner__rotating-75d3d62d2691e22483f40b7cc4ae531c.gif";